import { removeAccents } from 'utils/oneLiners';

export function buildIndexedData(data, fields) {
  return (data ?? []).map(item => ({
    ...item,
    ftIndex: removeAccents(
      (fields ?? [])
        .map(f => item?.[f] ?? '')
        .join(' ')
    ).toUpperCase(),
  }));
}

export function filterByTeamAndSearch(indexedData, { teamId, search, teamIdField = 'TeamId' }) {
  const teamFiltered = teamId ? indexedData?.filter(p => p?.[teamIdField] === teamId) : indexedData;
  const searchWords = (search ?? '').trim() !== ''
    ? removeAccents((search ?? '').trim().toUpperCase()).split(' ')
    : [];
  if (searchWords.length === 0) return teamFiltered;
  return teamFiltered?.filter(p => {
    for (const word of searchWords) {
      if ((p.ftIndex ?? '').indexOf(word) === -1) return false;
    }
    return true;
  });
}


